import { AppUpdate } from '@/types/updates';

export const update_2026_05: AppUpdate = {
  id: 'beta-launch-2026-05',
  slug: 'private-beta-launch-and-cloud-sync',
  title: 'Current Status: The Beta Era & Cloud Infrastructure',
  description: 'We are officially entering our private beta phase. This milestone is about stabilizing the infrastructure and opening the doors to our first wave of creators.',
  date: 'May 20, 2026',
  timestamp: 1779321600,
  category: 'NEWS',
  version: '0.9.9',
  readTime: '4 min read',
  author: {
    name: 'FCG Dev',
    role: 'Lead Architect'
  },
  content: [
    {
      type: 'heading',
      content: 'Welcome to the Beta Collective'
    },
    {
      type: 'text',
      content: 'After months of intensive development, Fun Circle Games is finally in the hands of real creators. We have recently invited a selected group of beta testers to push the limits of our Rhythmic and Escape modes. While we aren\'t "publicly live" yet, this phase is critical for ensuring the engine is rock-solid for everyone.'
    },
    {
      type: 'heading',
      content: 'Universal Cloud Sync'
    },
    {
      type: 'text',
      content: 'With the arrival of beta testers, we have fully activated our Cloud Infrastructure. We are using Cloudflare D1 and R2 to handle universal cloud saves. This means your simulations, custom synth presets, and MIDI mappings are now saved to your account and accessible from any browser, anywhere in the world.'
    },
    {
      type: 'list',
      content: [
        'Storage Manager: A new dashboard feature to manage your saved simulations and export history.',
        'High-Bitrate Recording: Finalized the 4K recording engine. You can now export your masterpieces directly from the studio.',
        'Bug Report System: Integrated a direct line from the studio to our dev team for immediate feedback during the beta.',
        'Optimization Pass: Final tweaks to the WebGL rendering pipeline to ensure maximal compatibility.'
      ]
    },
    {
      type: 'heading',
      content: 'The Journey Ahead'
    },
    {
      type: 'text',
      content: 'Our beta testers are already uncovering incredible ways to use the engine that we never imagined. From complex mathematical art pieces to high-energy rhythm games, the diversity of content being created is inspiring.'
    },
    {
      type: 'highlight',
      content: '"We are in the final mile of development. Every bit of feedback from this beta phase is being poured directly back into the core engine to ensure that our public debut is nothing short of perfect."'
    },
    {
      type: 'heading',
      content: 'What We Are Testing Now'
    },
    {
      type: 'text',
      content: 'Currently, we are stress-testing the "Multi-Sim" logic with long-duration recordings and verifying that our "Audio Slicer" works across all major MIDI formats. If you are part of the beta, thank you for being a pioneer in this journey. If you aren\'t yet, keep an eye on our "Updates" page—the doors will be opening wider very soon.'
    }
  ]
};
